export default function StreamInputDescUdpUnicast({ input }) {
  return <>UDP unicast {input.port} @ {input.iface} {input.iface_ip || "UNKNOWN"}</>;
}
